// extracted by mini-css-extract-plugin
module.exports = {"container":"Copyright_container__2zf59"};